import { render, staticRenderFns } from "./ChangeRequests.vue?vue&type=template&id=69986fc6&scoped=true&"
import script from "./ChangeRequests.vue?vue&type=script&lang=ts&"
export * from "./ChangeRequests.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeRequests.vue?vue&type=style&index=0&id=69986fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69986fc6",
  null
  
)

export default component.exports